// extracted by mini-css-extract-plugin
module.exports = {"alert":"FrontpageContactAlert_alert___KOEw","white":"FrontpageContactAlert_white__TWHLu","yellow":"FrontpageContactAlert_yellow__1ukPN"};